import { forwardRef } from 'react';

import { Close, Content, Overlay, DialogContentProps as RadixDialogContentProps } from '@radix-ui/react-dialog';
import clsx from 'clsx';

import CloseIcon from '~/icons/close.svg';

import styles from './dialog.module.css';

import { Icon } from '../Icon/Icon';

export type DialogContentProps = Omit<RadixDialogContentProps, 'asChild'> & {
	onCloseClick?: () => void;
	side?: 'left' | 'right';
};

export const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(({ children, onCloseClick, side = 'right', className, ...props }, forwardedRef) => {
	return (
		<>
			<Overlay className={styles.overlayCover} />

			<Content
				className={clsx(styles.content, side === 'right' && styles.right, className)}
				{...props}
				ref={forwardedRef}
				aria-modal="true"
				// Setting tabIndex to undefined prevents the DialogContent from receiving focus
				// and allows focus to naturally flow to interactive elements within the dialog
				tabIndex={undefined}
			>
				<Close asChild>
					<button
						type="button"
						className={styles.closeOverlay}
						onClick={onCloseClick}
						aria-hidden
					></button>
				</Close>
				<div className={clsx(styles.pane, side === 'right' && styles.right)}>
					{children}
					<Close asChild>
						<button
							type={'button'}
							className={styles.closeButton}
							onClick={onCloseClick}
							aria-label="Close"
						>
							<Icon size="lg">
								<CloseIcon />
							</Icon>
						</button>
					</Close>
				</div>
			</Content>
		</>
	);
});
